module.exports = __webpack_public_path__ + "static/media/circle.fragment.50dca4ab.glsl";